import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import Link from 'next/link'

import { useAuth } from 'src/hooks/useAuth'

const TERMS_OF_USE_URL = 'https://www.cxpify.com/terms-of-use'
const PRIVACY_POLICY_URL = 'https://www.cxpify.com/privacy-policy/'

const TermsAcceptanceDialog = () => {
  const { showTermsModal, acceptTerms, isAcceptingTerms } = useAuth()
  const [agreed, setAgreed] = useState(false)

  return (
    <Dialog
      disableRestoreFocus
      open={showTermsModal}
      disableEscapeKeyDown
      aria-labelledby='terms-acceptance-dialog-title'
      aria-describedby='terms-acceptance-dialog-description'
      sx={{
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: 450,
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <DialogTitle
          id='terms-acceptance-dialog-title'
          sx={{
            textAlign: 'left',
            fontSize: '1.25rem !important',
            fontWeight: 600,
            backgroundColor: '#1B205C',
            color: 'white'
          }}
        >
          Terms of Use Acceptance
        </DialogTitle>
        <DialogContent sx={{ p: 4, mb: 1, mt: 3 }}>
          <FormControlLabel
            sx={{ alignItems: 'flex-start', mx: 0 }}
            control={<Checkbox checked={agreed} onChange={e => setAgreed(e.target.checked)} sx={{ pt: 0 }} />}
            label={
              <Typography variant='body2' sx={{ textAlign: 'left', color: '#444', fontWeight: 'bold', lineHeight: 1.7 }}>
                I acknowledge that I have read, understood, and agree to the cXpify Platform{' '}
                <Link href={TERMS_OF_USE_URL} target='_blank' rel='noopener noreferrer'>
                  Terms of Use
                </Link>{' '}
                and{' '}
                <Link href={PRIVACY_POLICY_URL} target='_blank' rel='noopener noreferrer'>
                  Privacy Policy
                </Link>
                . I confirm that I am authorized to accept these terms on behalf of my organization.
              </Typography>
            }
          />
          <DialogContentText
            id='terms-acceptance-dialog-description'
            sx={{ textAlign: 'left', color: '#666', fontSize: '0.85rem', fontWeight: 'bold', mt: 8, lineHeight: 1.7 }}
          >
            By selecting &quot;Accept &amp; Continue&quot;, you agree to be legally bound by the cXpify Platform
            Terms of Use. If you don&apos;t agree, do not access or use the Services.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 2, p: 4, pt: 1 }}>
          <Button
            variant='contained'
            size='large'
            onClick={acceptTerms}
            disabled={!agreed || isAcceptingTerms}
            startIcon={isAcceptingTerms ? <CircularProgress size={16} /> : null}
            sx={{ px: 6, py: 1.5, fontSize: '1rem' }}
          >
            {isAcceptingTerms ? 'Agreeing...' : 'Agree & Continue'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default TermsAcceptanceDialog
